import $ from 'jquery';
import Swal from 'sweetalert2';
import { saveServizio } from '../../api';
import 'inputmask/dist/jquery.inputmask.min.js'; // https://github.com/RobinHerbots/Inputmask/issues/2298
import { setServizio } from '~loader/loader-utils';
import { getUser } from '~src/user';
import { onErrorShowMessage } from '~src/errors';
import { trackEvent } from '~src/tracking';

function addInputMaskAfter() {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  let yyyy = today.getFullYear();

  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  const maxDate = `${dd}/${mm}/${yyyy}`;
  const maxDateTime = `${dd}/${mm}/${yyyy} 23:59`;
  $('.inputmaskDateTimeToday').inputmask('datetime', {
    inputFormat: 'dd-mm-yyyy HH:MM',
    placeholder: 'gg-mm-aaaa hh:mm',
    showMaskOnHover: true,
    separator: '-',
    min: '01/01/1000 00:00',
    max: maxDateTime,
  });
  $('.inputmaskDate').inputmask('datetime', {
    inputFormat: 'dd-mm-yyyy',
    placeholder: 'gg-mm-aaaa',
    showMaskOnHover: true,
    separator: '-',
    min: '01/01/1000',
    max: maxDate,
  });
}

function validateModalForm(nomeFormPassed) {
  var errorSummary = $('#error-summary ul');
  errorSummary.empty();
  $('#error-summary').hide();
  $('.error-message').remove();

  $(`#${nomeFormPassed} input[aria-required="true"]`).each(function () {
    if ($(this).is('fieldset')) {
      if (!$(this).find('input:checked').length > 0) {
        $(this).attr('aria-invalid', true);
        const errortxt = $(this).find('legend').text();
        errorSummary.append('<li>' + errortxt + '</li>');
        $(this).append(
          '<span role="alert" class="error-message">Seleziona una della opzioni</span>'
        );
      } else {
        $(this).attr('aria-invalid', false);
      }
    }
    if ($(this).is('input[type="text"],textarea')) {
      if ($(this).val() == '' || $(this).val().includes('hh:mm')) {
        $(this).attr('aria-invalid', true);
        const errortxt = $(this).prev('label').text();
        errorSummary.append('<li>' + errortxt + '</li>');
        $(this)
          .parent()
          .append(
            '<span role="alert" class="error-message">Compila questo campo</span>'
          );
      } else {
        $(this).attr('aria-invalid', false);
      }
    }
  });

  if ($('#sesso').val() < 0) {
    $('#sesso').attr('aria-invalid', true);
    const errortxt = $('#sesso')
      .parents('.select-wrapper')
      .prev('label')
      .text();
    errorSummary.append('<li>' + errortxt + '</li>');
    $('#sesso')
      .parent()
      .append(
        '<span role="alert" class="error-message">Seleziona una della opzioni</span>'
      );
  } else {
    $('#sesso').attr('aria-invalid', false);
  }

  if ($('[aria-invalid="true"]').length > 0) {
    $('#error-summary').fadeIn();
    window.scrollTo(0, 0);
  } else {
    return true;
  }
}

export const initNewServizioForm = () => {
  const html = `<form class="form-horizontal"  method="post" enctype="multipart/form-data" id = 'form-aggiungi-defunto' name = 'form-aggiungi-defunto' >
  <div class="row" >
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <h6 class="mt-1 mb-3 modal-subtitle">
      Crea un servizio per precompilare in automatico il progetto che stai creando
    </h6>
    <div class="form-group">
      <label for="gender">Sesso *</label>
      <select id="sesso" aria-invalid="false" aria-required="true" name="sesso" class="select"  >
      <option value="-1"></option>
      <option value="m">Uomo</option>
      <option value="f">Donna</option>
      </select>
    </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
     <div class="form-group">
        <label>Cognome *</label>
        <input type="text" name="cognome" id="cognome" class="form-control" placeholder="Cognome" required="required" aria-required="true">
     </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
     <div class="form-group">
        <label>Nome *</label>
        <input type="text" name="nome" id="nome"  class="form-control" placeholder="Nome" aria-required="true" >
     </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
     <div class="form-group">
        <label>Data di Nascita</label>
        <div class="input-group">
           <input type="text" name="data_nascita" id="data_nascita" class="form-control inputmaskDate" value="" >
        </div>
     </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
     <div class="form-group">
        <label>Data e ora del decesso *</label>
        <div class="input-group">
           <input type="text" name="data_decesso" id="data_decesso" aria-required="true" style="width:100%;" class="form-control inputmaskDateTimeToday" value="" >
        </div>
     </div>
     </div>
        <h6 class="ml-3 mt-1 mb-3 modal-subtitle">
        N.B. I campi con * sono obbligatori
        </h6>
</div>
</form>
`;
  $('#editor-form-aggiungi-servizio').html(html);
  $('#sesso').select2({
    width: '100%',
    theme: 'bootstrap4',
    placeholder: { id: '-1', text: 'Seleziona il genere...' },
  });
  addInputMaskAfter();
};

$('body').on('click', '#salva-servizio', async function () {
  const invioPermesso = validateModalForm('form-aggiungi-defunto');

  if (!invioPermesso) {
    return;
  }

  const { user } = await getUser();
  const nome = $('#nome').val();
  const cognome = $('#cognome').val();
  const sesso = $('#sesso').val();
  const raw_data_morte = $('#data_decesso').val();
  const raw_data_nascita = $('#data_nascita').val();
  const user_pointer = user.objectId;

  const [dateDeath, timeDeath] = raw_data_morte.split(' ');
  const [dayDeath, monthDeath, yearDeath] = dateDeath.split('-');
  const [hourDeath, minDeath] = timeDeath.split(':');

  const data_morte = new Date(
    Date.UTC(
      yearDeath,
      parseInt(monthDeath) - 1,
      dayDeath,
      hourDeath,
      minDeath,
      0
    )
  );

  const payload = {
    data: {
      nome,
      cognome,
      sesso,
      data_morte,
      user_pointer,
      pratica: false,
      cimiteriale: false,
      noleggio_automezzi: false,
      funebre: true,
    },
    meta: {
      dateFields: ['data_morte', 'data_nascita'],
    },
  };

  if (raw_data_nascita) {
    const [day, month, year] = raw_data_nascita.split('-');
    payload.data.data_nascita = new Date(
      Date.UTC(year, parseInt(month) - 1, day, 0, 0, 0)
    );
  }

  Swal.fire({
    text: 'Sto salvando il servizio...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
  try {
    const response = await saveServizio(payload);
    $('#modalEditorAggiungiServizio').modal('hide');
    setServizio(response.data.data, true);
    Swal.close();
    trackEvent('Create Funeral Service', {
      success: true,
    });
  } catch (err) {
    onErrorShowMessage();
    console.error(err);
    trackEvent('Create Funeral Service', {
      success: false,
    });
  }
});

export default initNewServizioForm;
